var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignSpeedLimitNarCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_nar_x5F_can_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "traffic_x5F_sign_x5F_speed_x5F_limit_x5F_nar_x5F_can"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M14,90V6c0-2.209,1.791-4,4-4h60c2.209,0,4,1.791,4,4v84c0,2.209-1.791,4-4,4H18 C15.791,94,14,92.209,14,90z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78,6v84H18V6H78 M78,4H18c-1.105,0-2,0.895-2,2v84c0,1.105,0.895,2,2,2h60c1.105,0,2-0.895,2-2V6C80,4.895,79.105,4,78,4 L78,4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.94,22.544L21.324,14h1.704l2.196,5.916L27.384,14h1.668l0.432,8.544h-1.428l-0.288-5.796l-2.1,5.796h-0.984 l-2.148-5.832l-0.24,5.832H20.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.024,14h1.764l2.724,8.544h-1.536l-0.552-1.728h-3.192l-0.564,1.728H30.3L33.024,14z M32.58,19.58h2.508l-1.26-3.972 L32.58,19.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.596,18.2L38.16,14h1.62l1.776,2.988L43.308,14h1.476l-2.436,4.2l2.508,4.344h-1.608l-1.848-3.132l-1.836,3.132h-1.476 L40.596,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.755,14h1.476v8.544h-1.476V14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.744,22.544L49.127,14h1.705l2.195,5.916L55.188,14h1.668l0.432,8.544h-1.428l-0.287-5.796l-2.102,5.796h-0.982 l-2.148-5.832l-0.24,5.832H48.744z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.739,14h1.476v5.808c0,0.32,0.032,0.588,0.097,0.804c0.063,0.216,0.164,0.39,0.3,0.522 c0.136,0.132,0.31,0.226,0.521,0.282s0.471,0.084,0.774,0.084c0.296,0,0.552-0.028,0.768-0.084 c0.217-0.056,0.393-0.15,0.528-0.282c0.136-0.132,0.236-0.306,0.3-0.522c0.064-0.216,0.097-0.484,0.097-0.804V14h1.476v5.772 c0,0.48-0.056,0.902-0.168,1.266c-0.112,0.364-0.294,0.668-0.546,0.912c-0.252,0.244-0.58,0.428-0.984,0.552 c-0.403,0.124-0.894,0.186-1.47,0.186s-1.066-0.062-1.47-0.186c-0.404-0.124-0.732-0.308-0.984-0.552 c-0.252-0.244-0.434-0.548-0.546-0.912c-0.112-0.364-0.168-0.786-0.168-1.266V14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.516,22.544L66.899,14h1.704l2.196,5.916L72.959,14h1.669l0.432,8.544h-1.428l-0.288-5.796l-2.101,5.796H70.26 l-2.148-5.832l-0.24,5.832H66.516z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignSpeedLimitNarCan);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_speed_limit_nar_can.c89afe2373662d7d90b533da7770b723.svg";
export { ForwardRef as ReactComponent };